const resource = {
    resource_identifier_in_use: 'Identyfikator API {{indicator}} jest już używany',
    cannot_delete_management_api: 'Nie można usunąć interfejsu API zarządzania GptHouse.',
    cannot_modify_management_api: 'Nie można modyfikować interfejsu API zarządzania GptHouse.',
};
export default Object.freeze(resource);
